<template>
  <svg
    :class="[active ? 'active-tooth' : '', xFlipped ? 'x-flip' : '', yFlipped ? 'y-flip' : '']"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26.93 49.33"
    v-if="variant === 1"
  >
    <title>Tooth Variant 1</title>
    <path
      class="a"
      d="M8.56,10.49S10.14-.25,12.28,1s5.65,13.44,5.65,13.44l-3.16,9-8-6.1Z"
    />
    <path
      class="b"
      d="M8.56,10.49S10.14-.25,12.28,1s5.65,13.44,5.65,13.44l-3.16,9-8-6.1Z"
    />
    <path
      class="a"
      d="M2.79,31.16S1.1,2.13,6.3,2.24c0,0,3.05-.56,4.85,13.67,0,0,2,8.13,4.18-1S19-3.86,20.42,2.35,22.9,29.69,22.9,29.69l-7.68,8.59Z"
    />
    <path
      class="b"
      d="M2.79,31.16S1.1,2.13,6.3,2.24c0,0,3.05-.56,4.85,13.67,0,0,2,8.13,4.18-1S19-3.86,20.42,2.35,22.9,29.69,22.9,29.69l-7.68,8.59Z"
    />
    <path
      class="a"
      d="M15.79,30.84s8.15-4,8.67-1.91,9,26.35-12.31,16.47c0,0,4.63.15,2.25,2.72-1.84,2-12.44.41-13.17-2.72S-2.24,27.54,8.34,29.63"
    />
    <path
      class="c"
      d="M15.79,30.84s8.15-4,8.67-1.91,9,26.35-12.31,16.47c0,0,4.63.15,2.25,2.72C12.64,50,2,48.53,1.23,45.4S-2.24,27.54,8.34,29.63"
    />
  </svg>
  <svg
    v-else-if="variant === 2"
    :class="[active ? 'active-tooth' : '', xFlipped ? 'x-flip' : '', yFlipped ? 'y-flip' : '']"

    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.63 58.8"
  >
   
    <title>tooth-variant-2</title>
    <path
      class="a"
      d="M3.56,21.61S3,.23,7.63.38c3.8.12,7,40.27,7,40.27l-4.28,10L1.4,44.78Z"
    />
    <path
      class="b"
      d="M3.56,21.61S3,.23,7.63.38c3.8.12,7,40.27,7,40.27l-4.28,10L1.4,44.78Z"
    />
    <path
      class="a"
      d="M12.78,38.46s1.86-1.78,2.38-.11S19.05,61.09,10.45,58c-1-.36-.34-2.63-2.42-3.1,0,0,1.83.08,1.57,2.55-.23,2.17-8.4.5-8.85-2.63s-1.27-17.45,3-15.59"
    />
    <path
      class="c"
      d="M12.78,38.46s1.86-1.78,2.38-.11S19.05,61.09,10.45,58c-1-.36-.34-2.63-2.42-3.1,0,0,1.83.08,1.57,2.55-.23,2.17-8.4.5-8.85-2.63s-1.27-17.45,3-15.59"
    />
  </svg>
  <svg
    v-else-if="variant === 3"
    :class="[active ? 'active-tooth' : '', xFlipped ? 'x-flip' : '', yFlipped ? 'y-flip' : '']"

    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.03 72.36"
  >
    
    </defs>
    <title>tooth-variant-3</title>
    <path
      class="a"
      d="M5.53,30.85C5.64,23.27,2.59-1.47,6.85.48,10,1.94,15.67,49.75,15.67,49.75l-4.28,10-9-5.89s3-17.22,3.09-23"
    />
    <path
      class="b"
      d="M5.53,30.85C5.64,23.27,2.59-1.47,6.85.48,10,1.94,15.67,49.75,15.67,49.75l-4.28,10-9-5.89S5.44,36.67,5.53,30.85Z"
    />
    <path
      class="a"
      d="M13.82,47.56s1.86-1.78,2.38-.1S22.43,59.35,14.37,69c-1.32,1.58-2.54,3.37-4.62,2.9,0,0-2.24-1.32-2.51-1.45C5.29,69.48,1,65.67.51,62.54s0-16.08,4.24-14.21"
    />
    <path
      class="c"
      d="M13.82,47.56s1.86-1.78,2.38-.1S22.43,59.35,14.37,69c-1.32,1.58-2.54,3.37-4.62,2.9,0,0-2.24-1.32-2.51-1.45C5.29,69.48,1,65.67.51,62.54s0-16.08,4.24-14.21"
    />
  </svg>
  <svg
    v-else-if="variant === 4"
    :class="[active ? 'active-tooth' : '', xFlipped ? 'x-flip' : '', yFlipped ? 'y-flip' : '']"

    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.04 59.14"
  >
    <title>tooth-variant-4</title>
    <path
      class="a"
      d="M11.16,21.26S10-.1,5.86.38C2.52.77,2.93,41,2.93,41l4.58,9.69,7.42-6.51Z"
    />
    <path
      class="b"
      d="M11.16,21.26S10-.1,5.86.38C2.52.77,2.93,41,2.93,41l4.58,9.69,7.42-6.51Z"
    />
    <path
      class="a"
      d="M4.15,37.56s-1.84-.34-2.39.34c-1,1.22-2.59,15.62.08,20.1.65,1.09,2.52.69,4.05.71,5,.09,8-.89,9.25-1.66s1-2.7,1.19-4.27c.44-3.05,1.12-16.32-3.11-14.45"
    />
    <path
      class="c"
      d="M4.15,37.56s-1.84-.34-2.39.34c-1,1.22-2.59,15.62.08,20.1.65,1.09,2.52.69,4.05.71,5,.09,8-.89,9.25-1.66s1-2.7,1.19-4.27c.44-3.05,1.12-16.32-3.11-14.45"
    />
  </svg>
  <svg
    v-else-if="variant === 5"
    :class="['tooth-5', active ? 'active-tooth' : '', xFlipped ? 'x-flip' : '', yFlipped ? 'y-flip' : '']"

    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26.93 49.33"
  >
    <title>tooth-variant-5</title>
    <path
      class="a"
      d="M24.14,18.17s1.69,29-3.5,28.92c0,0-3.05.57-4.86-13.67,0,0-2-8.13-4.18,1S8,53.19,6.52,47,4,19.64,4,19.64l7.68-8.59Z"
    />
    <path
      class="b"
      d="M24,19.05s1.8,28.16-3.39,28c0,0-3.05.57-4.86-13.67,0,0-2-8.13-4.18,1S8,53.19,6.52,47,4,20.64,4,20.64"
    />
    <path
      class="b"
      d="M11.14,18.49S3,22.48,2.48,20.4s-9-26.35,12.31-16.47c0,0-4.64-.15-2.26-2.71C14.3-.68,25,.8,25.7,3.93s3.47,17.86-7.1,15.78"
    />
  </svg>
</template>

<script>
export default {
  props: {
    variant: {
      type: Number,
      default: 2
    },
    variantOptions: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    xFlipped() {
      return this.variantOptions && this.variantOptions.indexOf("x")>-1
    },
    yFlipped() {
      return this.variantOptions && this.variantOptions.indexOf("y")>-1
    }
  }
};
</script>
<style lang="stylus" scoped>
svg
  &.x-flip
    transform scale(-1, 1)
  &.y-flip
    transform scale(1, -1)
  &.x-flip.y-flip
    transform scale(-1, -1)
.a
  fill #fff
  /.active-tooth &
    fill #ccc
.b,
.c
  fill none
  stroke blue_brand
  stroke-width 0.75px
.c
  stroke-linecap round
  
</style>
